

export const phonesData = [
    {
      id: 1,
      model: "iPhone 15 Pro Max",
      desc: "Apple's latest flagship iPhone with advanced A17 Bionic chip and ProMotion OLED display.",
      price: 1299,
      image: "./assets/iPhone-15-Pro-Max.png",
      qty: 1,
    },
    {
      id: 2,
      model: "Samsung Galaxy S24 Ultra",
      desc: "Samsung's ultra-premium Galaxy S24 Ultra with Exynos 2200 and 200MP camera sensor.",
      price: 1199,
      image: "./assets/Samsung-Galaxy-S24-Ultra.png",
      qty: 1,
    },
    {
      id: 3,
      model: "Google Pixel 8 Pro",
      desc: "Google's Pixel 8 Pro featuring Google Tensor 2 chip and exceptional computational photography.",
      price: 1099,
      image: "./assets/Google-Pixel-8-Pro.png",
      qty: 1,
    },
    {
      id: 4,
      model: "OnePlus 10 Pro",
      desc: "OnePlus 10 Pro with Snapdragon 8 Gen 2 and 144Hz Fluid AMOLED display.",
      price: 1099,
      image: "./assets/OnePlus-10-Pro.png",
      qty: 1,
    },
    {
      id: 5,
      model: "Xiaomi Mi 12 Ultra",
      desc: "Xiaomi Mi 12 Ultra featuring Snapdragon 8 Gen 2 and groundbreaking camera technology.",
      price: 999,
      image: "./assets/Xiaomi-Mi-12-Ultra.png",
      qty: 1,
    },
    {
      id: 6,
      model: "Sony Xperia XZ5 Premium",
      desc: "Sony Xperia XZ5 Premium with 4K HDR OLED display and Snapdragon 888 chipset.",
      price: 1099,
      image: "./assets/Sony-Xperia-XZ5-Premium.png",
      qty: 1,
    },
    {
      id: 7,
      model: "LG Velvet Plus",
      desc: "LG Velvet Plus with Snapdragon 888 and 120Hz P-OLED display.",
      price: 999,
      image: "./assets/LG-Velvet-Plus.png",
      qty: 1,
    },
    {
      id: 8,
      model: "Nokia X30 5G TA-1450",
      desc: "Nokia X30 5G TA-1450  with Snapdragon 888 and Zeiss optics quad-camera setup.",
      price: 1099,
      image: "./assets/Nokia-X30-5G-TA-1450.png",
      qty: 1,
    },
    {
      id: 9,
      model: "Huawei P50 Pro Plus",
      desc: "Huawei P50 Pro Plus with Kirin 9000E and Leica quad-camera system.",
      price: 1199,
      image: "./assets/Huawei-P50-Pro-Plus.png",
      qty: 1,
    },
    {
      id: 10,
      model: "Asus ROG Phone 6 Ultimate",
      desc: "Asus ROG Phone 6 Ultimate with Snapdragon 8 Gen 2 Plus and 144Hz AMOLED display.",
      price: 1299,
      image: "./assets/Asus-ROG-Phone-6-Ultimate.png",
      qty: 1,
    },
    {
      id: 11,
      model: "iPhone 12",
      desc: "Apple's iPhone 12 with A14 Bionic chip, Super Retina XDR display, and dual-camera system for stunning photos and videos.",
      price: 799,
      image: "./assets/iPhone-12.png",
      qty: 1
    },
    {
      id: 12,
      model: "Samsung Galaxy S21 Ultra",
      desc: "Samsung's premium smartphone with a powerful Exynos 2100 processor, Dynamic AMOLED 2X display, and a versatile quad-camera setup.",
      price: 1199,
      image: "./assets/Samsung-Galaxy-S21-Ultra.png",
      qty: 1
    }
  ];
  

  